import cloneDeep from 'lodash/cloneDeep';
import type { BoardState, GridPosition } from '../../../game/boardMVC/types';

export function applyVerticalSymmetry(originalBoard: BoardState): BoardState {
  const symmetricalBoard = cloneDeep(originalBoard);
  const { rows, cols } = symmetricalBoard;

  const getReflectedEntries = <T extends GridPosition>(collection: T[]): T[] => {
    const output: T[] = [];
    collection.forEach((stack) => {
      const colYOffset = stack.x % 2 === 0 ? 0 : 1;
      const centerY = Math.floor(rows / 2) - colYOffset;

      if (stack.y >= centerY) return;

      output.push({
        ...stack,
      });

      if (stack.y !== centerY || colYOffset === 1) {
        output.push({
          ...stack,
          y: rows - stack.y - colYOffset - 1,
        });
      }
    });
    return output;
  };

  const stacks = getReflectedEntries(symmetricalBoard.stacks);
  const hiddenStacks = getReflectedEntries(symmetricalBoard.hiddenStacks);
  const blockers = getReflectedEntries(symmetricalBoard.blockers ?? []);
  const recordedXYs: GridPosition[] = [...stacks, ...blockers, ...hiddenStacks];

  // Hide every other stack in the bottom row.
  const finalY = rows - 1;
  for (let x = 1; x < cols; x += 2) {
    if (recordedXYs.some((gridXY) => gridXY.x === x && gridXY.y === finalY)) continue;
    hiddenStacks.push({
      x,
      y: finalY,
    });
  }

  return {
    ...symmetricalBoard,
    stacks,
    hiddenStacks,
    blockers,
  };
}
